import { PLANTING_STATUS, TASK_STATUS, isStageStep, stageTaskNameToStepName } from '@seedplanner/shared-utils';

export function getPlantingStage({
  plantingStatus,
  tasks,
}: {
  readonly plantingStatus: string;
  readonly tasks: {
    readonly task_name: string;
    readonly task_status: string;
    readonly task_time: number;
  }[];
}): string | undefined {
  if (plantingStatus === PLANTING_STATUS.COMPLETED || plantingStatus === PLANTING_STATUS.PLANNED) {
    return undefined;
  }
  const completedStageTasks = tasks.filter((t) => t.task_status === TASK_STATUS.COMPLETED && isStageStep(t.task_name));
  if (completedStageTasks.length === 0) {
    return undefined;
  }
  completedStageTasks.sort((a, b) => b.task_time - a.task_time);

  return stageTaskNameToStepName(completedStageTasks[0].task_name);
}
